import styled, { css } from 'styled-components';

const Author = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  ${(props) =>
    props.pageType === 'direction' &&
    css`
      ${Content.ColumnSide},
      .button-wrap {
        ${maxWidth(vars.breakpoints.tablet - 1)`
          display: none;
        `}
      }
    `}
`;
Author.Img = styled.a`
  display: flex;
  text-decoration: none;

  img {
   width: 60px;
   height: 60px;
   object-fit: contain;
  }
`;

Author.Info = styled.div`
   display:flex;
   flex-direction:column;
   gap:4px;
   font-weight: normal;
   line-height: 1.6;
   font-size: 16px;
   color: rgb(0, 0, 0);
`;

Author.Name = styled.a`
  font-weight: 700;
  text-decoration: none;
  color: inherit;
  font-size: 1.2rem;
`;

Author.Desc = styled.div``;


export default Author;